import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { updateTeamSettings, updateNewUser } from "@api/settings/team"
import { can, MODIFY_USERS_AND_ROLES } from "@src/helpers/authorization"

const Header = ({ updateTeamSettings, updateNewUser, search, defaultRoleID, canModify }) => (
  <div className='flex items-center'>
    <h4>Users</h4>
    <div className='flex items-center justify-end flex-auto'>
      <input
        value={search}
        placeholder='Search for a user...'
        className='cs-input'
        onChange={e => updateTeamSettings({ search: e.target.value })}/>
      {canModify && (
        <button onClick={() => updateNewUser({ show: true, role_id: defaultRoleID })} className='ml2 cs-button'>
          Add Team Members
        </button>
      )}
    </div>
  </div>
)

Header.propTypes = {
  updateTeamSettings: PropTypes.func.isRequired,
  updateNewUser: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  defaultRoleID: PropTypes.string,
  canModify: PropTypes.bool.isRequired
}

const mapStateToProps = (state, ownProps) => ({
  search: state.settings.team.search,
  defaultRoleID: state.settings.organization.default_role,
  canModify: can(state.user, [MODIFY_USERS_AND_ROLES])
})

const mapDispatchToProps = dispatch => ({
  updateTeamSettings: bindActionCreators(updateTeamSettings, dispatch),
  updateNewUser: bindActionCreators(updateNewUser, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)
